import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Checkbox, Input, Row, Col, DatePicker } from 'antd';

import Enums from 'utils/EnumsManager';


const propTypes = {
  checked: PropTypes.bool,
  fieldKey: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onCheckChange: PropTypes.func,
  onValueChange: PropTypes.func,
  theme: PropTypes.oneOf(Enums.ThemeTypesInArray).isRequired,
  value: PropTypes.string,
};


const FilterField = ({
  checked,
  fieldKey,
  label,
  onCheckChange,
  onValueChange,
  theme,
  value,
}) => {

  const _onCheckChange = e => {
    if (_.isFunction(onCheckChange)) {
      // Attention: Antd Checkbox returns a converted Event target which is not a conventional Event object
      const { checked, field } = e.target;
      onCheckChange(field, checked);
    }
  }

  const _onValueChange = e => {
    if (_.isFunction(onValueChange)) {
      const { value, dataset } = e.target;
      onValueChange(dataset.field, value);
    }
  }

  const onDateChange = (date, dateString) => {
    if(_.isFunction(onValueChange)){
      onValueChange('birthday', dateString)
    }
  }

  const format = 'YYYY-MM-DD'

  const dateTimePicker = (
      <DatePicker
        format={format}
        // Invalid cases whose value will convert to 'invalid date' include empty string, null and non-digit string and so on.
        // More cases and info pls refer to => https://momentjs.com/docs/#/parsing/is-valid/
        value={moment(value, format).isValid() ? moment(value, format) : undefined}
        onChange={onDateChange}
      />
  )
  return (
    <Row className="mb-sm">
      <Col xs={24} sm={8}>
        <Checkbox
          checked={checked}
          className={`${theme}-theme-checkbox`}
          field={fieldKey}
          onChange={_onCheckChange}
        >
          {label}
        </Checkbox>
      </Col>
      <Col xs={24} sm={16}>
        {fieldKey === 'birthday' ? 
          dateTimePicker : 
          <Input
            data-field={fieldKey}
            placeholder={label}
            size="small"
            value={value}
            onChange={_onValueChange}
          />
        }
      </Col>
    </Row>
  );
}


FilterField.propTypes = propTypes;
export default FilterField;


// WEBPACK FOOTER //
// ./src/components/ui/FilterField/index.jsx